import { apiClient } from "@/api";
import type { ApiResponse, PaginatedData } from "@/types";
import type { Project, ProjectDeleteRes } from "@/types/project";
import type { ProjectReportResponse } from "@/services/chat-service";
import type { AxiosRequestConfig } from "axios";

export async function getProjects(
  page: number = 1,
  size: number = 10,
  config?: AxiosRequestConfig,
) {
  return await apiClient.get<ApiResponse<PaginatedData<Project>>>(
    `/projects/?page=${page}&page_size=${size}`,
    config,
  );
}

export async function deleteProject(projectId: string, config?: AxiosRequestConfig) {
  await apiClient.delete<ApiResponse<ProjectDeleteRes>>(`/projects/${projectId}`, config);
}

export async function getProjectReport(projectId: string, config?: AxiosRequestConfig): Promise<ProjectReportResponse> {
  const { data } = await apiClient.get<ApiResponse<ProjectReportResponse>>(
    `/projects/${projectId}/report`,
    config
  );
  return data.data!;
}
